<template>
  <!-- Spunta privacy dei moduli di contatto (#708). Il testo è composto dalle
       stesse parti che il documento salva (consent/privacyConsent.js). Un
       click sul link non spunta la casella: il link è contenuto interattivo
       della label. -->
  <label class="ic-form__privacy">
    <input
      :data-testid="testId"
      type="checkbox"
      :checked="modelValue"
      @change="$emit('update:modelValue', $event.target.checked)"
    />
    <span :data-testid="`${testId}-text`">{{ parts.before }}<a
        :data-testid="`${testId}-link`"
        class="ic-form__privacy-link"
        :href="policyUrl"
        target="_blank"
        rel="noopener noreferrer"
      >{{ parts.link }}</a>{{ parts.after }}</span>
  </label>
</template>

<script>
import { PRIVACY_CONSENT_PARTS, PRIVACY_POLICY_URL } from "@/consent/privacyConsent.js";

export default {
  name: "PrivacyConsentCheckbox",
  props: {
    modelValue: { type: Boolean, default: false },
    testId: { type: String, default: "privacy" },
  },
  emits: ["update:modelValue"],
  data() {
    return { parts: PRIVACY_CONSENT_PARTS, policyUrl: PRIVACY_POLICY_URL };
  },
};
</script>
